import { ConsultaPadrao } from "../../../components/ConsultaPadrao";
import { model_centro_resultado } from "../../../models";

export const CentroResultado = () => {
    const columns = [
        { field: 'centresdescricao', header: 'Descrição' },
        { field: 'centrestipo', header: 'Tipo', body: (e: any) => <div>{e.centrestipo === 0 ? 'CUSTO' : 'RECEITA'}</div> },
        { field: 'centrestativo', header: 'Ativo' },
        { field: 'functions', style: { width: '4rem' } }
    ];

    return (
        <ConsultaPadrao model={model_centro_resultado} columns={columns} />
    )
}